(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cp-photo-reviews')) {
    customElements.define('cp-photo-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-review-track]');
        this.querySelector('[data-review-previous]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-review-next]')?.addEventListener('click', () => this.move(1));
      }

      move(direction) {
        if (!this.track) return;
        this.track.scrollBy({ left: this.track.clientWidth * direction, behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
